import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";

export const unauthorizedInterceptor: HttpInterceptorFn = (request, next) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const condition1 = error.status === 401;
      // const condition2 = error.status === 409 && error.error.message.includes('- no Session');
      if (
        condition1
        // || condition2
      ) {
        authService.logout(() => { router.navigate(['/login']).then() });
      }
      return throwError(() => error);
    }));
};
